import React from "react";
import PropTypes from "prop-types";

import { Type } from "discover.medical.react-component-library";
import {
  StyledRegimenTitle,
  StyledCourseTitle,
  StyledMetadataWrapper,
} from "./_.styled";

const ChemoRegimenMetadata = ({ metadata }) => {
  const { regimenTitle, courseTitle } = metadata || {};

  if (!regimenTitle) {
    return null;
  }

  return (
    <StyledMetadataWrapper>
      {courseTitle ? (
        <>
          <StyledRegimenTitle>{regimenTitle}</StyledRegimenTitle>
          <StyledCourseTitle marginTop="xs" element="h2" fontFamily="secondary">
            {courseTitle}
          </StyledCourseTitle>
        </>
      ) : (
        <Type marginTop="sm" element="h2" fontFamily="secondary">
          {regimenTitle}
        </Type>
      )}
    </StyledMetadataWrapper>
  );
};

ChemoRegimenMetadata.propTypes = {
  metadata: PropTypes.shape({
    regimenTitle: PropTypes.string.isRequired,
    courseTitle: PropTypes.string,
  }),
};

ChemoRegimenMetadata.displayName = "ChemoRegimenMetadata";
export default ChemoRegimenMetadata;
